import en from "./locale/en";
import nl from "./locale/nl";

export default {
  en: en,
  nl: nl
};